import { createSlice } from '@reduxjs/toolkit';
import { TableData } from '@uikit/Tables/types';
import { notesApi } from '@store/rtk';
import { formatUTCToLocal } from '@src/utils';
import { TABLE_COLUMNS } from '@uikit/Tables/columns';

type notesSliceType = {
  notesData: TableData;
  notesByContact: TableData;
  notesByAssociatedData: TableData;
};

const { notesByAssociatedColumns } = TABLE_COLUMNS;

const initialState: notesSliceType = {
  notesData: {
    columns: TABLE_COLUMNS.notesColumns,
    rows: [],
    size: 5,
  },
  notesByContact: {
    columns: TABLE_COLUMNS.notesByContactColumns,
    rows: [],
    size: 5,
  },
  notesByAssociatedData: {
    columns: notesByAssociatedColumns,
    rows: [],
    size: 5,
  },
};

export const notesSlice = createSlice({
  name: 'notes',
  initialState,
  reducers: {
    deleteNotesData(state) {
      state.notesByAssociatedData = {
        ...state.notesByAssociatedData,
        rows: [],
      };
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      notesApi.endpoints.getNotes.matchFulfilled,
      (state, { payload }) => {
        const { rideOrStandingOrderNotesColumns, notesColumns } = TABLE_COLUMNS;
        if (payload.content && Array.isArray(payload.content)) {
          state.notesData = {
            ...state.notesData,
            columns:
              payload.table === 'rideNotes' ||
              payload.table === 'standingOrderNotes'
                ? rideOrStandingOrderNotesColumns
                : notesColumns,
            rows: [
              ...payload.content.map((el) => ({
                ...el,
                actionTime: formatUTCToLocal(el.actionTime),
              })),
            ],
            ...payload,
            requestTablePageChange: notesApi.endpoints.getNotes,
          };
        }
      }
    );
    builder.addMatcher(
      notesApi.endpoints.getNotesByContact.matchFulfilled,
      (state, { payload }) => {
        const { notesByContactColumns } = TABLE_COLUMNS;
        state.notesByContact = {
          ...state.notesByContact,
          columns: notesByContactColumns,
          rows: [
            ...payload.content.map((el) => ({
              ...el,
              actionTime: formatUTCToLocal(el.actionTime),
            })),
          ],
          ...payload,
          requestTablePageChange: notesApi.endpoints.getNotesByContact,
        };
      }
    );
    builder.addMatcher(
      notesApi.endpoints.getNotesByAssociatedId.matchFulfilled,
      (state, { payload }) => {
        if (payload.content && Array.isArray(payload.content)) {
          state.notesByAssociatedData = {
            ...state.notesByAssociatedData,
            ...payload,
            rows: [
              ...payload.content.map((el, idx) => ({
                ...el,
              })),
            ],
            requestTablePageChange: notesApi.endpoints.getNotesByAssociatedId,
          };
        }
      }
    );
    builder.addMatcher(
      notesApi.endpoints.createNotesByContact.matchFulfilled,
      (state, { payload }) => {}
    );
  },
});

export const { deleteNotesData } = notesSlice.actions;

export const selectNotes = (state: { notes: notesSliceType }) => state.notes;
export const notesReducer = notesSlice.reducer;
